<template>
<div class="chapter">
<div class="inner_page">
<p class="dedication">Paola. <br/>Every single heartbeat.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// viper_00000.vue?5d6f3206